// CETIBER — Shared content data

export const CONTACT = {
  nome: "Cetiber — Sistemas de Fixação, Lda.",
  morada: "Via Central de Milheiros 584, 4475-330 Milheirós, Maia",
  moradaLinhas: [
    "Cetiber — Sistemas de Fixação, Lda.",
    "Via Central de Milheiros 584",
    "4475-330 Milheirós, Maia",
    "Portugal",
  ],
  telefone: "22 943 6320",
  telefoneHref: "tel:+351229436320",
  email: "geral@cetiber.pt",
  emailHref: "mailto:geral@cetiber.pt",
  mapsQuery: "Cetiber Sistemas de Fixação, Via Central de Milheiros 584, 4475-330 Milheirós",
};

export const NAV = [
  { to: "/", label: "Início" },
  { to: "/produtos", label: "Produtos" },
  { to: "/marcas", label: "Marcas" },
  { to: "/quem-somos", label: "Quem Somos" },
  { to: "/contactos", label: "Contactos" },
];

export const CATEGORIES = [
  {
    slug: "fixacao-metalica",
    code: "01",
    title: "Fixação Metálica",
    short: "Varões, parafusos, porcas, anilhas e rebites",
    description:
      "Soluções completas de fixação metálica em diversos acabamentos.",
    image:
      "/uploads/cat-1-fixacao.png",
  },
  {
    slug: "fixacao-betao",
    code: "02",
    title: "Fixação em Betão",
    short: "Buchas e ancoragens",
    description:
      "Buchas de expansão, ancoragens mecânicas e químicas para betão. Elevada capacidade de carga e durabilidade.",
    image:
      "/uploads/cat-2-buchas.png",
  },
  {
    slug: "ferramentas",
    code: "03",
    title: "Ferramentas de Corte",
    short: "Brocas, discos, fresas",
    description:
      "Soluções para criar todo o tipo de furos, discos de corte e rebarbar, lamelas para profissionais da construção e metalomecânica.",
    image:
      "/uploads/cat-3-ferramentas.png",
  },
  {
    slug: "quimicos",
    code: "04",
    title: "Químicos",
    short: "Silicones, lubrificantes, ancoragem química",
    description:
      "Silicones, lubrificantes multiusos, desengordurantes, ancoragem química e vedantes de alto desempenho.",
    image:
      "/uploads/cat-4-quimicos.png",
  },
  {
    slug: "cabos",
    code: "05",
    title: "Cabos e Correntes",
    short: "Cabos de aço e acessórios",
    description:
      "Cabos de aço galvanizado e inox, correntes, olhais e respetivos acessórios de içamento.",
    image:
      "/uploads/cat-5-cabos.png",
  },
  {
    slug: "estruturas",
    code: "06",
    title: "Estruturas",
    short: "Perfis metálicos",
    description:
      "Perfil perfurado em galvanizado e inox, acessórios para montagem de estruturas industriais e comerciais.",
    image:
      "/uploads/cat-6-estruturas.png",
  },
  {
    slug: "abracadeiras",
    code: "07",
    title: "Abraçadeiras",
    short: "Fixação leve",
    description:
      "Abraçadeiras metálicas e em nylon, para fixação de tubagens, cabos e componentes em instalações industriais e prediais.",
    image:
      "/uploads/cat-7-abracadeiras.png",
  },
  {
    slug: "epi",
    code: "08",
    title: "Equipamento de Proteção (EPI)",
    short: "Luvas, óculos, proteção auditiva, calçado e outros",
    description:
      "Equipamentos de proteção individual certificados: luvas, óculos, capacetes, proteção auditiva e respiratória, calçado de segurança e outros.",
    image:
      "/uploads/cat-8-epi.png",
  },
];

export const BRANDS = [
  { name: "BESSEY", logo: "/uploads/brand-bessey.png" },
  { name: "BIANDITZ", logo: "/uploads/brand-bianditz.png" },
  { name: "BRALO", logo: "/uploads/brand-bralo.png" },
  { name: "CETAFORM", logo: "/uploads/brand-cetaform.png" },
  { name: "INDEX", logo: "/uploads/brand-index.png" },
  { name: "IZAR", logo: "/uploads/brand-izar.png" },
  { name: "MASTER PROF", logo: "/uploads/brand-masterprof.png" },
  { name: "MUNDIAL", logo: "/uploads/brand-mundial.png" },
  { name: "STANLEY", logo: "/uploads/brand-stanley.png" },
  { name: "STAYER", logo: "/uploads/brand-stayer.png" },
  { name: "WD-40", logo: "/uploads/brand-wd40.png" },
  { name: "WIKUS", logo: "/uploads/brand-wikus.png" },
];

export const MEDIA = {
  logo: "/cetiber-logo.png",
  hero_truck:
    "/uploads/truck.jpg",
  slogan:
    "/uploads/slogan.jpg",
  fleet:
    "/uploads/fleet.jpg",
  warehouse:
    "/uploads/warehouse.jpg",
  showroom_overview:
    "https:/uploads/showroom-overview.png",
  showroom_wd40:
    "/uploads/showroom-wd40.png",
  showroom_screwdrivers:
    "/uploads/showroom-screwdrivers.png",
  showroom_ral:
    "/uploads/showroom-ral.png",
  showroom_sockets:
    "/uploads/showroom-sockets.png",
  warehouse_aerial:
    "/uploads/warehouse-aerial.png",
  counter:
    "/uploads/counter.png",
};
